module.exports = __webpack_public_path__ + "img/wallets_border.bb13c624.svg";